import { ThemeProvider } from "@mui/material";
import PageTemplate from "../../components/common/particles.jsx/PageTemplate";
import HOC from "../../components/HOC";
import { theme } from "../../components/constants/muiTheme";
import PurchaseProductList from "../../components/screen/purchaseOnlinePbf/PurchaseProductList";
import PurchaseProductListBanner from "../../components/screen/purchaseOnlinePbf/PurchaseProductListBanner";

const PurchaseProductListPbfPage = ({ isBanner }) => {
  return (
    <PageTemplate
      mainComponent={
        <ThemeProvider theme={theme}>
          {isBanner ? <PurchaseProductListBanner /> : <PurchaseProductList />}
        </ThemeProvider>
      }
      pageRole={3}
      bgColor={"gray"}
      noPadding={true}
    />
  );
};

export default HOC(PurchaseProductListPbfPage);
